import _classCallCheck from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/kivateknoloji/kivacloud/corona-ux/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { BaseTransformer } from './BaseTransformer';
export var ActivityTransformer = /*#__PURE__*/function (_BaseTransformer) {
  _inherits(ActivityTransformer, _BaseTransformer);
  var _super = _createSuper(ActivityTransformer);
  function ActivityTransformer() {
    _classCallCheck(this, ActivityTransformer);
    return _super.apply(this, arguments);
  }
  _createClass(ActivityTransformer, null, [{
    key: "fetch",
    value: function fetch(data) {
      return {
        content: data.content,
        attachments: data.attachments,
        seen: data.seen,
        notify_time: data.notify_time,
        notify_on: data.notify_on,
        created_by_fullname: data.created_by_fullname,
        created_by: data.created_by,
        message: data.message,
        params: data.params
      };
    }
  }, {
    key: "send",
    value: function send(data) {
      return {};
    }
  }]);
  return ActivityTransformer;
}(BaseTransformer);